import { useTranslation } from 'react-i18next'
import { Pill } from './Pill'

const STYLE = {
  pending: 'bg-gray-100 text-gray-700 border-gray-200',
  printed: 'bg-green-100 text-green-800 border-green-200',
  // The label exists but no paper came out: amber, like the replay, because the package
  // still needs the operator to press Reimprimir (or open the PDF with the link).
  label_unprinted: 'bg-amber-100 text-amber-800 border-amber-200',
  label_replayed: 'bg-amber-100 text-amber-800 border-amber-200',
  label_failed: 'bg-red-100 text-red-800 border-red-200',
}

// One outcome → colour + copy table for the card and the strip (spec §5.2, §5.4).
export const OutcomeBadge = ({ outcome }) => {
  const { i18n } = useTranslation()
  return <Pill tone={STYLE[outcome] || STYLE.pending}>{i18n.t(`c2c_receiving.outcome.${outcome}`, { defaultValue: outcome })}</Pill>
}
